import React, { FC, useState } from 'react';
import { Button, Radio, Space } from 'antd';
import styles from './Filters.module.less';
import { FilterTitle } from './FilterTitle';

type Props = {
  value?: string;
  onChange?: (value?: string) => void;
  onCancel?: () => void;
};

export const SortTypeSelector: FC<Props> = (props) => {
  const { onChange } = props;
  const [value, setValue] = useState<string | undefined>(props.value);
  return (
    <Space direction="vertical" size={16} className={styles.filterArea}>
      <FilterTitle
        id={'most-relevant-filter'}
        title={(value ?? 'relevant') === 'relevant' ? 'Most Relevant' : 'Most Recent'}
        onApply={() => onChange?.(value)}
        onCancel={props.onCancel}
      />
      <Radio.Group onChange={(e) => setValue(e.target.value)} value={value ?? 'relevant'}>
        <Space direction="vertical">
          <Radio value={'relevant'}>Most Relevant</Radio>
          <Radio value={'recent'}>Most Recent</Radio>
        </Space>
      </Radio.Group>
      <Button
        className={styles.applyButton}
        type={'primary'}
        size={'small'}
        onClick={() => onChange?.(value)}>
        Apply
      </Button>
    </Space>
  );
};
